const indexItems = [
  {
    title: '热播国产剧',
    desc: '最新国产剧集一网打尽，都市、古装、悬疑全收录',
    icon: 'ri-tv-2-line',
    count: '2,856部',
    color: 'primary',
  },
  {
    title: '日韩剧场',
    desc: '韩剧日剧同步更新，追剧党必备专区',
    icon: 'ri-global-line',
    count: '3,421部',
    color: 'accent',
  },
  {
    title: '欧美大片',
    desc: '好莱坞巨制、经典老片、独立佳作精彩纷呈',
    icon: 'ri-film-line',
    count: '5,112部',
    color: 'secondary',
  },
  {
    title: '动漫专区',
    desc: '日漫国漫热血番、治愈番分类齐全',
    icon: 'ri-ghost-smile-line',
    count: '4,638部',
    color: 'primary',
  },
  {
    title: '综艺娱乐',
    desc: '热门综艺全程高能，搞笑治愈停不下来',
    icon: 'ri-emotion-laugh-line',
    count: '1,920部',
    color: 'accent',
  },
  {
    title: '纪录片库',
    desc: 'BBC、Discovery经典纪录片，涨知识必备',
    icon: 'ri-earth-line',
    count: '3,045部',
    color: 'secondary',
  },
  {
    title: '怀旧经典',
    desc: 'TVB老剧、经典国产剧、港片黄金时代回顾',
    icon: 'ri-time-line',
    count: '4,201部',
    color: 'primary',
  },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1024px] mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <span className="inline-flex items-center gap-1 px-3 py-1 rounded-full bg-secondary-500/10 text-secondary-400 text-xs font-medium mb-3 whitespace-nowrap">
            <i className="ri-apps-2-line text-xs"></i>
            分类导航
          </span>
          <h2 className="text-xl md:text-3xl font-bold text-foreground-100 mb-2">
            影视专题
          </h2>
          <p className="text-foreground-500 text-sm">按类型快速找到你想看的内容</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
          {indexItems.slice(0, 4).map((item, idx) => (
            <div
              key={idx}
              className="group p-4 rounded-xl bg-background-200/70 border border-background-300/40 hover:border-background-400/60 transition-all cursor-pointer"
            >
              <div
                className={`w-10 h-10 flex items-center justify-center rounded-lg mb-3 ${
                  item.color === 'primary'
                    ? 'bg-primary-500/15 text-primary-400'
                    : item.color === 'accent'
                      ? 'bg-accent-500/15 text-accent-400'
                      : 'bg-secondary-500/15 text-secondary-400'
                }`}
              >
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-200 mb-1">{item.title}</h3>
              <p className="text-foreground-600 text-xs mb-2">{item.desc}</p>
              <span className="text-xs text-foreground-500">{item.count}</span>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mt-3">
          {indexItems.slice(4).map((item, idx) => (
            <div
              key={idx}
              className="group p-4 rounded-xl bg-background-200/70 border border-background-300/40 hover:border-background-400/60 transition-all cursor-pointer"
            >
              <div
                className={`w-10 h-10 flex items-center justify-center rounded-lg mb-3 ${
                  item.color === 'primary'
                    ? 'bg-primary-500/15 text-primary-400'
                    : item.color === 'accent'
                      ? 'bg-accent-500/15 text-accent-400'
                      : 'bg-secondary-500/15 text-secondary-400'
                }`}
              >
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-200 mb-1">{item.title}</h3>
              <p className="text-foreground-600 text-xs mb-2">{item.desc}</p>
              <span className="text-xs text-foreground-500">{item.count}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}